let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("feyFu")).then(() => parcelRequire('8UvDw'));